export default __webpack_public_path__ + "3e9db947b6dc04dd48bb13de27ea7edf.svg";